
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Device } from '@capacitor/device';
import { ErrorMessage } from '@hookform/error-message';
import { yupResolver } from '@hookform/resolvers/yup';
import { saveAs } from 'file-saver';
import { useContext, useEffect, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import 'react-phone-input-2/lib/style.css';
import { useNavigate } from 'react-router-dom';
import addIcon from '../../assets/images/add-icon.svg';
import user from "../../assets/images/menu/account.svg";
import Checkbox from '../../components/layouts/CheckBox';
import PageLoader from '../../components/layouts/PageLoader';
import TopHeader from '../../components/layouts/TopHeader';
import Button from '../../components/ui/Button';
import CustomInput from '../../components/ui/CustomInput';
import CustomPhoneInput from '../../components/ui/CustomPhoneInput';
import CustomReactSelect from '../../components/ui/CustomReactSelect';
import Skeleton from '../../components/ui/Skeleton';
import { ApiConstants } from '../../constants/ApiConstants';
import { ApiTypes } from '../../constants/Constants';
import { Routes } from '../../constants/RouteConstants';
import authContext from '../../context/authContext';
import useMakeRequest from '../../utils/ApiHelper';
import { validImageTypes, validateImage } from '../../utils/Helper';
import ProfileValidation from '../../validations/auth/ProfileValidation';
import DoNotSellMyPersonalInfoModal from '../cms-public/DoNotSellMyPersonalInfoModal';
import PageLayout from '../../components/ui/PageLayout';



interface profileInputs {
    name: string;
    email: string;
    phone_country_code: string,
    phone_number: string,
    country: string,
    state: string,
    locality: object | null,
    income: string,
    profile_pic: any;
    monthly_work_hour: string;
    show_income_to_other_hh: boolean;
    receive_marketing_emails: boolean;
    share_usage_data: boolean;
};

const EditProfile = () => {

    const contentRef = useRef<HTMLDivElement | null>(null);

    const [profileImage, setProfileImage]: any = useState(null);
    const [country, setCountry] = useState('')
    const [state, setState] = useState('')
    const [myUserData, setMyUserData] = useState()
    const navigate = useNavigate();

    const profile: any = useContext(authContext);
    const countries = useMakeRequest();
    const localities = useMakeRequest();
    const cmsPage = useMakeRequest();
    const states = useMakeRequest();
    const update_profile = useMakeRequest();
    const [image, setImage]: any = useState('')
    const [isIos, setIsIos] = useState(false);


    const userData = useMakeRequest();


    useEffect(() => {
        userData.makeRequest({ url: ApiConstants?.GetDownload })
    }, [])

    useEffect(() => {
        if (userData?.status) {
            setMyUserData(userData?.data?.data)
        }
    }, [userData])


    const { register, watch, setValue, formState: { errors }, handleSubmit, trigger, getValues } = useForm<profileInputs>({
        mode: 'onChange',
        resolver: yupResolver(ProfileValidation) as any
    });



    const handleProImg = (e: any) => {
        const file = e.target.files?.[0];
        if (file) {
            const validationError = validateImage(file, validImageTypes);
            if (validationError !== true) {
                toast.error(validationError as string);
                return;
            }
            const imageURL = URL.createObjectURL(file);
            setProfileImage(imageURL);
            setValue("profile_pic", file);
            setImage(file)
            $('.btn-close-select-photo').click()
        }
    };

    const handleMobileNumber = (value: any, code: any) => {
        const regex = new RegExp(code?.dialCode);
        const phone = value.replace(regex, "");
        setValue('phone_country_code', code?.dialCode);
        setValue('phone_number', phone);
        trigger("phone_number");
    }

    useEffect(() => {
        console.log("profile?.data: ", profile?.data)
        if (profile?.data) {
            setValue('name', profile?.data.name);
            setValue('email', profile?.data.email);
            setValue('phone_country_code', profile?.data?.phone_country_code)
            setValue('phone_number', profile?.data?.phone_number)
            setValue('profile_pic', profile?.data?.profile_pic)
            setValue('country', profile?.data?.country)
            setValue('state', profile?.data?.state);
            setValue('locality', profile?.data?.locality_detail);
            setValue(
                'income',
                profile?.data?.income
                    ? Number(profile?.data?.income).toLocaleString('en-US')
                    : ''
            );
            setValue('monthly_work_hour', profile?.data?.monthly_work_hour);
            setValue('receive_marketing_emails', profile?.data?.receive_marketing_emails);
            setValue('share_usage_data', profile?.data?.share_usage_data);
            setValue('show_income_to_other_hh', profile?.data?.show_income_to_other_hh);
            setProfileImage(profile?.data?.profile_pic)
            setCountry(profile?.data?.country)
            setState(profile?.data?.state)
        }
    }, [profile?.data])


    const onSubmit = (data: any) => {
        console.log("data: ", data)
        console.log("receive_marketing_emails ", watch("receive_marketing_emails"))
        console.log("share_usage_data ", watch("share_usage_data"))
        const payload = {
            ...data,
            income: data?.income ? data.income.replace(/,/g, '') : '',
            locality: data?.locality?.value,
            profile_pic: watch('profile_pic'),
            receive_marketing_emails: watch("receive_marketing_emails"),
            share_usage_data: watch("share_usage_data"),
            show_income_to_other_hh: watch("show_income_to_other_hh"),
        }


        toast.promise(
            update_profile.makeRequest({ url: ApiConstants?.UpdateProfile, payload, type: ApiTypes?.FORM_DATA }),
            {
                loading: 'Processing...',
                success: (data: any) => data.message,
                error: (error: any) => error.message,
            }
        );
    }

    useEffect(() => {
        if (update_profile?.status) {
            // saveToStorage({ key: StorageConstants?.USER_DETAIL, value: update_profile?.data })
            profile.makeRequest({ url: ApiConstants?.Profile, type: ApiTypes?.GET })
            navigate(Routes?.Profile)
        }
        if (update_profile?.error) {
            console.error(update_profile?.error)
        }
    }, [update_profile?.status, update_profile?.error])

    useEffect(() => {
        countries.makeRequest({ url: ApiConstants?.LocationGet, payload: { type: 1, showAll: true } })

        const checkDeviceType = async () => {
            const info = await Device.getInfo()
            if (info?.platform === 'ios') {
                setIsIos(true)
            }
        }
        checkDeviceType()
    }, [])

    useEffect(() => {
        if (countries?.status) {
            setValue('country', countries?.data?.data[0]?.value)
        }
    }, [countries?.status])

    useEffect(() => {
        if (watch('country')) {
            states.makeRequest({ url: ApiConstants?.LocationGet, payload: { type: 2, showAll: true, list_id: watch('country') } })
        }
    }, [watch('country')])

    useEffect(() => {
        if (watch('state')) {
            localities.makeRequest({ url: ApiConstants?.LocationGet, payload: { type: 3, showAll: true, list_id: watch('state') } })
        }
    }, [watch('state')])

    const handleOpenCamera = async () => {
        const permissionResult = await Camera.checkPermissions();
        if (permissionResult?.camera === 'granted') {
            const photo = await Camera.getPhoto({
                resultType: CameraResultType.Uri,
                source: CameraSource.Camera,
                quality: 60,
            });
            if (photo?.webPath) {
                const response = await fetch(photo.webPath);
                const blob = await response.blob();
                const file = new File([blob], `profile_pic_${Date.now()}.${photo?.format}`, { type: blob.type });
                setValue('profile_pic', file)
                setProfileImage(photo?.webPath);
                $('.btn-close-select-photo').click()
            }
        } else if (permissionResult?.camera === 'denied') {
            toast.error('Camera permission denied. Please enable it in settings to use this feature.');
        } else {
            const photo = await Camera.getPhoto({
                // allowEditing: false,
                resultType: CameraResultType.Uri,
                source: CameraSource.Camera,
                quality: 100,
            });
            if (photo?.webPath) {
                const response = await fetch(photo.webPath);
                const blob = await response.blob();
                const file = new File([blob], `profile_pic_${Date.now()}.${photo?.format}`, { type: blob.type });
                setValue('profile_pic', file)
                setProfileImage(photo?.webPath);
                $('.btn-close-select-photo').click()
            }
        }
    };

    const handleOpenGallery = async () => {
        const permissionResult = await Camera.checkPermissions();
        if (permissionResult?.photos === 'granted') {
            const image = await Camera.getPhoto({
                resultType: CameraResultType.Uri,
                source: CameraSource.Photos,
                allowEditing: false,
                quality: 60
            });
            if (image?.webPath) {
                const response = await fetch(image.webPath);
                const blob = await response.blob();
                const file = new File([blob], `profile_pic_${Date.now()}.${image?.format}`, { type: blob.type });
                setValue('profile_pic', file)
                setProfileImage(image?.webPath);
                $('.btn-close-select-photo').click()
            }
        } else if (permissionResult?.camera === 'denied') {
            toast.error('Photo Library permission denied. Please enable it in settings to use this feature.');
        } else {
            const image = await Camera.getPhoto({
                resultType: CameraResultType.Uri,
                source: CameraSource.Photos,
                allowEditing: false,
                quality: 60
            });
            if (image?.webPath) {
                const response = await fetch(image.webPath);
                const blob = await response.blob();
                const file = new File([blob], `profile_pic_${Date.now()}.${image?.format}`, { type: blob.type });
                setValue('profile_pic', file)
                setProfileImage(image?.webPath);
                $('.btn-close-select-photo').click()
            }
        }
    };

    const viewCmsPage = (slug: string) => {
        cmsPage.makeRequest({ payload: { detail_id: slug }, url: ApiConstants?.CmsPagesDetail })
    }

    const downloadCSV = () => {

        if (myUserData) {

            const jsonData = myUserData
            const flatten = (obj: { [x: string]: any; }, parent = '', res = {}) => {
                for (let key in obj) {
                    const propName = parent ? `${parent}.${key}` : key;
                    if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
                        flatten(obj[key], propName, res);
                    } else {
                        // @ts-ignore
                        res[propName] = obj[key];
                    }
                }
                return res;
            };

            const flattenedData = flatten(jsonData);
            const csvHeader = Object.keys(flattenedData).join(',') + '\n';
            const csvRow = Object.values(flattenedData)
                .map(value => `"${String(value).replace(/"/g, '""')}"`)
                .join(',') + '\n';

            const blob = new Blob([csvHeader + csvRow], { type: 'text/csv;charset=utf-8;' });
            saveAs(blob, 'my_data.csv');
        }

    };

    useEffect(() => {
        const handleContentClick = (event: { target: any; preventDefault: () => void; }) => {
            const clickedElement = event.target;

            console.log("clickedElement: ", clickedElement);

            // Identify the link: "Do not share my personal info"
            // Still recommend using a more robust identifier (ID/class from CMS) if possible.
            if (clickedElement.textContent.includes('Do not share my personal info')) {
                event.preventDefault(); // Prevent default link behavior

                // Get a reference to the first modal element
                const firstModalElement = $('#exampleModal'); // jQuery selector

                // 1. Trigger the close button click on the first modal
                firstModalElement.find('.btn-close').click();

                // 2. Listen for the 'hidden.bs.modal' event on the first modal
                // This ensures the first modal is fully closed before opening the second.
                firstModalElement.one('hidden.bs.modal', function () {
                    // 3. Show the second modal
                    // @ts-ignore
                    $('#personalLinkModal').modal('show');
                });
            }
        };

        const currentContentRef = contentRef.current;
        if (currentContentRef) {
            // Attach the event listener to the modal-body div
            currentContentRef.addEventListener('click', handleContentClick);
        }

        // Cleanup: remove the event listener when the component unmounts
        return () => {
            if (currentContentRef) {
                currentContentRef.removeEventListener('click', handleContentClick);
            }
        };
    }, [cmsPage]);

    const receiveMarketingEmails = watch("receive_marketing_emails", false);
    const shareUsageData = watch("share_usage_data", false);

    const hasProfilePic = profileImage
    return (
        <>
            <PageLayout headerName='Edit Profile' onlyTitle={false}>

                {/* {profile?.loading ? <PageLoader /> : ''}
            <TopHeader headerName="Edit Profile" /> */}
                <div className="auth-page login-page">
                    <div className="auth-container">
                        <form onSubmit={handleSubmit(onSubmit)} className='auth-form-wrap mt-0'>
                            <div className="auth-form">
                                <div className="auth-form-fields">
                                    <div className='profile-img-area'>
                                        <div className='profile-wrap-border'>
                                            <div className='profile-inner-img'>
                                                {hasProfilePic ? (
                                                    <Zoom>
                                                        <img className="profile-img" src={profileImage} alt="" />
                                                    </Zoom>
                                                ) : (
                                                    <img src={user} alt="photo" className="dummy-profile" />
                                                )}
                                            </div>
                                        </div>

                                        <label className='add-photo-btn' data-bs-toggle="offcanvas" data-bs-target="#photoSelect">
                                            <img
                                                src={addIcon}
                                                alt={'photo'}
                                                className="add-icon-img"
                                            /> Add Photo
                                        </label>

                                        <input hidden id="openCameraOptions" type="file" onChange={handleProImg} accept="image/*" />
                                        <input hidden id="openGallery" type="file" onChange={handleProImg} accept="image/*" />
                                        <input hidden id="openCamera" type="file" onChange={handleProImg} accept="image/*" capture="environment" />
                                    </div>

                                    {/* <div className="mb-3 com-input-grp">
                        <label className="form-label">Name<span className='label-star'>*</span></label>
                        <input type="text" className="form-control" placeholder='Enter name' {...register('name')} />
                        <ErrorMessage errors={errors} name="name" render={({ message }) => <p className='valid-error'>{message}</p>} />
                    </div> */}

                                    <CustomInput
                                        label="Name"
                                        type="text"
                                        placeholder="Enter name"
                                        required
                                        {...register('name')}
                                        error={errors.name?.message}
                                    />

                                    {/* <div className="mb-3 com-input-grp">
                        <label className="form-label">Email<span className='label-star'>*</span></label>
                        <input type="email" className="form-control" placeholder='Enter email' {...register('email')} disabled />
                        <ErrorMessage errors={errors} name="email" render={({ message }) => <p className='valid-error'>{message}</p>} />
                    </div> */}

                                    <CustomInput
                                        label="Email"
                                        type="email"
                                        placeholder="Enter email"
                                        required
                                        disabled
                                        {...register('email')}
                                        error={errors.email?.message}
                                    />

                                    {/* <div className="mb-3 com-input-grp">
                        <label className="form-label">Mobile Number</label>
                        <div className='phone-code-select-wrap'>
                            <PhoneInput country={'us'} containerClass="phone-code-select"
                                inputClass="phone-code-input" placeholder="" disableInitialCountryGuess={false}
                                enableLongNumbers={false} countryCodeEditable={false} value={`${watch('phone_country_code')}${watch('phone_number')}`}
                                onChange={handleMobileNumber} />
                            <ErrorMessage errors={errors} name="phone_number" render={({ message }) => <p className='valid-error'>{message}</p>} />
                        </div>
                    </div> */}

                                    <CustomPhoneInput
                                        label="Mobile Number"
                                        value={`${watch('phone_country_code') || ''}${watch('phone_number') || ''}`}
                                        onChange={handleMobileNumber}
                                        error={errors.phone_number?.message}
                                        defaultCountry="us"
                                        placeholder="+1 (555) 000-0000"
                                    />

                                    {/* <div className="mb-3 com-input-grp">
                        <label className="form-label">Country<span className='label-star'>*</span></label>
                        <div className='custom-select'>
                            <ReactSelect
                                options={countries?.data?.data}
                                value={{ value: countries?.data?.data?.[0]?.value, label: countries?.data?.data?.[0]?.label }}
                                className="com-r-select"
                                classNamePrefix="com-r-select"
                                placeholder="Please select household name"
                                onChange={(selectedOption: any) => {
                                    setValue("country", selectedOption ? selectedOption?.value : "");
                                    trigger("country")
                                }}
                                closeMenuOnScroll={true}
                                closeMenuOnSelect={true}
                                isLoading={countries?.loading}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                }}
                            />
                        </div>
                        <ErrorMessage errors={errors} name="country" render={({ message }) => <p className='valid-error'>{message}</p>} />
                    </div> */}

                                    <CustomReactSelect
                                        label="Country"
                                        required
                                        options={countries?.data?.data}
                                        value={{
                                            value: countries?.data?.data?.[0]?.value,
                                            label: countries?.data?.data?.[0]?.label
                                        }}
                                        placeholder="Please select household name"
                                        onChange={(selectedOption: any) => {
                                            setValue("country", selectedOption ? selectedOption?.value : "");
                                            trigger("country");
                                        }}
                                        isLoading={countries?.loading}
                                        error={errors}
                                        errorName="country"
                                        closeMenuOnScroll={true}
                                        closeMenuOnSelect={true}
                                    />

                                    {/* <div className="mb-3 com-input-grp">
                        <label className="form-label">State<span className='label-star'>*</span></label>
                        <div className='custom-select'>
                            <ReactSelect
                                options={states?.data?.data}
                                className="com-r-select"
                                classNamePrefix="com-r-select"
                                defaultValue={profile?.data?.state_detail}
                                // value={watch('state')}
                                // value={{ value: 1, label: state }}
                                // value={watch("state")}
                                placeholder="Select state"
                                onChange={(selectedOption: any) => {
                                    setValue("state", selectedOption ? selectedOption?.value : "");
                                    trigger("state")
                                    setValue('locality', null)
                                    localities.makeRequest({ url: ApiConstants?.LocationGet, payload: { type: 3, list_id: selectedOption?.value, showAll: true } })
                                }}
                                closeMenuOnScroll={true}
                                closeMenuOnSelect={true}
                                isLoading={states?.loading}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                }}
                            />
                        </div>
                        <ErrorMessage errors={errors} name="state" render={({ message }) => <p className='valid-error'>{message}</p>} />
                    </div> */}

                                    <CustomReactSelect
                                        label="State"
                                        required
                                        options={states?.data?.data}
                                        className="com-r-select"
                                        classNamePrefix="com-r-select"
                                        defaultValue={profile?.data?.state_detail}
                                        // value={watch('state')}
                                        // value={{ value: 1, label: state }}
                                        // value={watch("state")}
                                        placeholder="Select state"
                                        onChange={(selectedOption: any) => {
                                            setValue("state", selectedOption ? selectedOption?.value : "");
                                            trigger("state")
                                            setValue('locality', null)
                                            localities.makeRequest({ url: ApiConstants?.LocationGet, payload: { type: 3, list_id: selectedOption?.value, showAll: true } })
                                        }}
                                        closeMenuOnScroll={true}
                                        closeMenuOnSelect={true}
                                        menuPosition="fixed"
                                        menuShouldScrollIntoView={false}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 })
                                        }}
                                        isLoading={states?.loading}
                                        error={errors}
                                        errorName="state"

                                    />

                                    {/* <div className="mb-3 com-input-grp">
                        <label className="form-label">Locality<span className='label-star'>*</span></label>
                        <div className='custom-select'>
                            <ReactSelect
                                options={localities?.data?.data}
                                defaultValue={profile?.data?.locality_detail}
                                className="com-r-select"
                                classNamePrefix="com-r-select"
                                placeholder="Select locality"
                                value={watch("locality")}
                                onChange={(selectedOption: any) => {
                                    setValue("locality", selectedOption ? selectedOption : "");
                                    trigger("locality")
                                }}
                                closeMenuOnScroll={true}
                                closeMenuOnSelect={true}
                                isLoading={localities?.loading}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                }}
                            />
                        </div>
                        <ErrorMessage errors={errors} name="locality" render={({ message }) => <p className='valid-error'>{message}</p>} />
                    </div> */}

                                    <CustomReactSelect
                                        label="Locality"
                                        required
                                        options={localities?.data?.data}
                                        defaultValue={profile?.data?.locality_detail}
                                        className="com-r-select"
                                        classNamePrefix="com-r-select"
                                        placeholder="Select locality"
                                        value={watch("locality")}
                                        onChange={(selectedOption: any) => {
                                            setValue("locality", selectedOption ? selectedOption : "");
                                            trigger("locality")
                                        }}
                                        closeMenuOnScroll={true}
                                        closeMenuOnSelect={true}
                                        menuPosition="fixed"
                                        menuShouldScrollIntoView={false}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 })
                                        }}
                                        isLoading={localities?.loading}
                                        error={errors}
                                        errorName="locality"
                                    />


                                    {/* <div className="mb-3 com-input-grp">
                        <label className="form-label">My Income (optional)
                            <abbr data-tooltip-id="my-income" className='text-decoration-none cursor-pointer'> <i className='icon-info ms-2'></i></abbr>
                        </label>
                        <ReactTooltip
                            style={{
                                zIndex: '1',
                                wordBreak: "break-word",
                                maxWidth: "90%"
                            }}
                            id="my-income"
                            place="bottom"
                            content="Income is only required for households using the income-adjusted split. If you enter your income on
this page, other household members may be able to estimate your income."
                        />

                        <div className='income-field'>
                            <input type="text" className="form-control" placeholder='$00.00' {...register("income")}
                                onInput={(e: any) => {
                                    let inputValue = e.target.value;
                                    inputValue = inputValue.replace(/[^0-9.]/g, '');
                                    const decimalCount = inputValue.split('.').length - 1;
                                    if (decimalCount > 1) {
                                        const parts = inputValue.split('.');
                                        inputValue = parts[0] + '.' + parts.slice(1).join('');
                                    }
                                    const parts = inputValue.split('.');
                                    if (parts[0].length > 7) {
                                        parts[0] = parts[0].substring(0, 7);
                                    }
                                    if (parts.length > 1) {
                                        parts[1] = parts[1]?.substring(0, 2);
                                    }
                                    inputValue = parts.join('.');
                                    e.target.value = inputValue;
                                }} />
                        </div>
                        <ErrorMessage errors={errors} name="income" render={({ message }) => <p className='valid-error'>{message}</p>} />
                    </div> */}

                                    <CustomInput
                                        label="Income"
                                        placeholder='$00.00'
                                        tooltip={{
                                            id: "my-income",
                                            content: "Income is only required for households using the income-adjusted split. If you enter your income on this page, other household members may be able to estimate your income.",
                                            place: "bottom"
                                        }}
                                        {...register('income')}
                                        onInput={(e: any) => {
                                            let value = e.target.value;

                                            // remove commas first
                                            value = value.replace(/,/g, '');

                                            // allow only numbers and decimal
                                            value = value.replace(/[^0-9.]/g, '');

                                            // allow only one decimal
                                            const decimalCount = value.split('.').length - 1;
                                            if (decimalCount > 1) {
                                                const parts = value.split('.');
                                                value = parts[0] + '.' + parts.slice(1).join('');
                                            }

                                            let parts = value.split('.');

                                            // limit integer length
                                            if (parts[0].length > 7) {
                                                parts[0] = parts[0].substring(0, 7);
                                            }

                                            // limit decimal to 2
                                            if (parts[1]) {
                                                parts[1] = parts[1].substring(0, 2);
                                            }

                                            // add commas to integer part
                                            parts[0] = Number(parts[0]).toLocaleString('en-US');

                                            e.target.value = parts.join('.');
                                        }}
                                        error={errors.income?.message}
                                    />

                                    <Checkbox
                                        register={register}
                                        labelText=""
                                        id='show_income_to_other_hh'
                                        name='show_income_to_other_hh'
                                        customLabelClassName="profile-check-box-label"
                                        links={[
                                            { text: 'Show income to other household members?', isLink: false }
                                        ]}
                                    />

                                    {/* <div className="mb-3 com-input-grp">
                        <label className="form-label">Hours of Employment (Monthly)

                            <abbr data-tooltip-id="hours-of-employment" className='text-decoration-none cursor-pointer'>
                                <i className='icon-info ms-2'></i></abbr></label>

                        <ReactTooltip
                            style={{
                                zIndex: '1',
                                wordBreak: "break-word",
                                maxWidth: "90%"
                            }}
                            id="hours-of-employment"
                            place="bottom"
                            content="This information is optional and will be visible to other household members. Please record the
average number of hours actually worked in a month, omitting paid time off and any form of leave."
                        />

                        <div className='income-field'>
                            <input type="text" className="form-control" placeholder='Enter hours'  {...register('monthly_work_hour')}
                                onInput={(e: any) => {
                                    let value = e.target.value;
                                    const match = value.match(/^(?!0+$)\d{1,3}$/);
                                    if (match) {
                                        e.target.value = match[0];
                                    } else {
                                        e.target.value = value.slice(0, -1);
                                    }
                                    if (e.target.value > 720) {
                                        e.target.value = 720
                                    }
                                }}
                            />
                        </div>
                        <ErrorMessage errors={errors} name="monthly_work_hour" render={({ message }) => <p className='valid-error'>{message}</p>} />
                    </div> */}

                                    <CustomInput
                                        label="Hours of Employment (Monthly)"
                                        placeholder="Enter hours"
                                        tooltip={{
                                            id: "hours-of-employment",
                                            content: "This information is optional and will be visible to other household members. Please record the average number of hours actually worked in a month, omitting paid time off and any form of leave.",
                                            place: "bottom"
                                        }}
                                        {...register('monthly_work_hour')}
                                        onInput={(e: any) => {
                                            let value = e.target.value;

                                            // Remove non-digits
                                            value = value.replace(/\D/g, "");

                                            // Prevent multiple leading zeros
                                            if (value === "00" || value === "000") {
                                                value = "0";
                                            }

                                            // If starts with 0 and has more digits, remove leading zero
                                            if (value.length > 1 && value.startsWith("0")) {
                                                value = value.replace(/^0+/, "");
                                            }

                                            // Limit to 3 digits
                                            if (value.length > 3) {
                                                value = value.slice(0, 3);
                                            }

                                            // Cap max value to 720
                                            if (Number(value) > 720) {
                                                value = "720";
                                            }

                                            e.target.value = value;
                                        }}
                                        error={errors.monthly_work_hour?.message}
                                    />

                                    <Checkbox
                                        register={register}
                                        labelText=""
                                        name='receive_marketing_emails'
                                        id={'receive_marketing_emails'}
                                        customLabelClassName="profile-check-box-label"
                                        links={[
                                            { text: 'I agree to receive notifications and emails about exclusive promotions, marketing offers, and other updates.', isLink: false }
                                        ]}
                                    />
                                    <Checkbox
                                        register={register}
                                        name='share_usage_data'
                                        id={'share_usage_data'}
                                        customLabelClassName="profile-check-box-label"
                                        labelText="Yes! I agree to advance household fairness by sharing usage and analytics data with Justivide. All data sharing is subject to the"
                                        links={[
                                            { text: 'Privacy Policy.', isLink: true, onClick: () => viewCmsPage('privacy-policy') },
                                        ]}
                                    />
                                    <div className="mb-3 mt-3 com-input-grp">
                                        <label className="form-label">Data</label>
                                        <a className="text-link"
                                            onClick={downloadCSV}
                                        >
                                            {'Request a copy of your data'}
                                        </a>
                                    </div>
                                </div>
                                <div className="auth-form-actions">
                                    <Button
                                        text='Continue'
                                        className='com-btn mb-3'
                                        type="submit"
                                        loading={update_profile?.loading}
                                    >
                                        Save
                                    </Button>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>

                {/*==== IMAGE SELECT DRAWER START ====*/}
                <div
                    className="offcanvas offcanvas-bottom inner-modal"
                    tabIndex={-1}
                    id="photoSelect"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    data-bs-scroll="false"
                    aria-labelledby="photoSelectLabel"
                    style={{ backgroundColor: '#fff', minHeight: '20%', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}
                >
                    <div className="offcanvas-body d-flex justify-content-center align-items-center flex-column">
                        {/* <label className="d-flex align-items-center justify-content-center w-100 btn btn-light my-2 py-3" htmlFor='openGallery'>
                        <i className="fa fa-camera me-3" aria-hidden="true"></i> Upload from Photos
                    </label>
                    {isMobile ? <label className="d-flex align-items-center justify-content-center w-100 btn btn-light mb-2 py-3" htmlFor='openCamera'>
                        <i className="fa fa-picture-o me-3" aria-hidden="true"></i> Take a Photo
                    </label> : ''}
                    <label className="d-flex align-items-center justify-content-center w-100 btn btn-secondary py-3 btn-close-select-photo" data-bs-dismiss="offcanvas" aria-label="Close">
                        Cancel
                    </label> */}

                        <label className="d-flex align-items-center justify-content-center w-100 btn btn-light my-2 py-3" onClick={handleOpenGallery}>
                            <i className="fa fa-camera me-3" aria-hidden="true"></i> Upload from Photos
                        </label>
                        {isMobile ? <label className="d-flex align-items-center justify-content-center w-100 btn btn-light mb-2 py-3" onClick={handleOpenCamera}>
                            <i className="fa fa-picture-o me-3" aria-hidden="true"></i> Take a Photo
                        </label> : ''}
                        <label className="d-flex align-items-center justify-content-center w-100 btn btn-secondary py-3 btn-close-select-photo" data-bs-dismiss="offcanvas" aria-label="Close">
                            Cancel
                        </label>

                    </div>
                </div>
                {/*==== IMAGE SELECT DRAWER END ====*/}

                <div ref={contentRef} className="modal fade inner-modal c" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title fs-5" id="exampleModalLabel">{cmsPage?.data?.data?.title}</h1>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                {
                                    cmsPage?.loading ?
                                        <>
                                            <Skeleton className='skeleton-loader mt-5' style={{ width: '50%', height: '20px' }} />
                                            <Skeleton className='skeleton-loader my-2' style={{ width: '60%', height: '20px' }} />
                                            <Skeleton className='skeleton-loader my-2' style={{ width: '100%', height: '20px' }} />
                                            <Skeleton className='skeleton-loader my-2' style={{ width: '80%', height: '20px' }} />
                                            <Skeleton className='skeleton-loader my-2' style={{ width: '90%', height: '20px' }} />

                                            <Skeleton className='skeleton-loader mt-5' style={{ width: '50%', height: '20px' }} />
                                            <Skeleton className='skeleton-loader my-2' style={{ width: '60%', height: '20px' }} />
                                            <Skeleton className='skeleton-loader my-2' style={{ width: '100%', height: '20px' }} />
                                            <Skeleton className='skeleton-loader my-2' style={{ width: '80%', height: '20px' }} />
                                            <Skeleton className='skeleton-loader my-2' style={{ width: '90%', height: '20px' }} />
                                        </>
                                        :
                                        <p dangerouslySetInnerHTML={{ __html: cmsPage?.data?.data?.content }}></p>
                                }            </div>
                            {/* <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" className="btn btn-primary">Save changes</button>
            </div> */}
                        </div>
                    </div>
                </div>

                <DoNotSellMyPersonalInfoModal cmsPage={cmsPage} />

                {/* <div className="modal fade inner-modal c" id="personalLinkModal" tabIndex={-1} aria-labelledby="personalLinkModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="personalLinkModalLabel">{"Do Not Sell My Personal Info"}</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {
                                cmsPage?.loading ?
                                    <>
                                        <Skeleton className='skeleton-loader mt-5' style={{ width: '50%', height: '20px' }} />
                                        <Skeleton className='skeleton-loader my-2' style={{ width: '60%', height: '20px' }} />
                                        <Skeleton className='skeleton-loader my-2' style={{ width: '100%', height: '20px' }} />
                                        <Skeleton className='skeleton-loader my-2' style={{ width: '80%', height: '20px' }} />
                                        <Skeleton className='skeleton-loader my-2' style={{ width: '90%', height: '20px' }} />

                                        <Skeleton className='skeleton-loader mt-5' style={{ width: '50%', height: '20px' }} />
                                        <Skeleton className='skeleton-loader my-2' style={{ width: '60%', height: '20px' }} />
                                        <Skeleton className='skeleton-loader my-2' style={{ width: '100%', height: '20px' }} />
                                        <Skeleton className='skeleton-loader my-2' style={{ width: '80%', height: '20px' }} />
                                        <Skeleton className='skeleton-loader my-2' style={{ width: '90%', height: '20px' }} />
                                    </>
                                    :
                                    <div className="auth-page pt-0">
                                        <form onSubmit={handleSubmit(onSubmit)} className='auth-form-wrap mt-0'>

                                            <div className="mb-3 com-input-grp">
                                                <label className="form-label">Country<span className='label-star'>*</span></label>
                                                <div className='custom-select'>
                                                    <ReactSelect
                                                        options={countries?.data?.data}
                                                        value={{ value: countries?.data?.data?.[0]?.value, label: countries?.data?.data?.[0]?.label }}
                                                        className="com-r-select"
                                                        classNamePrefix="com-r-select"
                                                        placeholder="Please select household name"
                                                        onChange={(selectedOption: any) => {
                                                            setValue("country", selectedOption ? selectedOption?.value : "");
                                                            trigger("country")
                                                        }}
                                                        closeMenuOnScroll={true}
                                                        closeMenuOnSelect={true}
                                                        isLoading={countries?.loading}
                                                    />
                                                </div>
                                                <ErrorMessage errors={errors} name="country" render={({ message }) => <p className='valid-error'>{message}</p>} />
                                            </div>

                                            <div className="mb-3 com-input-grp">
                                                <label className="form-label">State<span className='label-star'>*</span></label>
                                                <div className='custom-select'>
                                                    <ReactSelect
                                                        options={states?.data?.data}
                                                        className="com-r-select"
                                                        classNamePrefix="com-r-select"
                                                        defaultValue={profile?.data?.state_detail}
                                                        // value={watch('state')}
                                                        // value={{ value: 1, label: state }}
                                                        // value={watch("state")}
                                                        placeholder="Select state"
                                                        onChange={(selectedOption: any) => {
                                                            setValue("state", selectedOption ? selectedOption?.value : "");
                                                            trigger("state")
                                                            setValue('locality', null)
                                                            localities.makeRequest({ url: ApiConstants?.LocationGet, payload: { type: 3, list_id: selectedOption?.value, showAll: true } })
                                                        }}
                                                        closeMenuOnScroll={true}
                                                        closeMenuOnSelect={true}
                                                        isLoading={states?.loading}
                                                    />
                                                </div>
                                                <ErrorMessage errors={errors} name="state" render={({ message }) => <p className='valid-error'>{message}</p>} />
                                            </div>

                                            <div className="mb-3 com-input-grp">
                                                <label className="form-label">Name<span className='label-star'>*</span></label>
                                                <input type="text" className="form-control" placeholder='Enter name' {...register('name')} />
                                                <ErrorMessage errors={errors} name="name" render={({ message }) => <p className='valid-error'>{message}</p>} />
                                            </div>

                                            <div className="mb-3 com-input-grp">
                                                <label className="form-label">Email<span className='label-star'>*</span></label>
                                                <input type="email" className="form-control" placeholder='Enter email' {...register('email')} />
                                                <ErrorMessage errors={errors} name="email" render={({ message }) => <p className='valid-error'>{message}</p>} />
                                            </div>



                                            <Button text='Continue' className='com-btn my-5 mx-auto' type="submit" loading={update_profile?.loading}> Save</Button>
                                        </form>

                                    </div>

                            }    
                             </div>

                    </div>
                </div>
            </div> */}
            </PageLayout>
        </>
    )
}

export default EditProfile
